<ng-container *ngIf="container">
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column flex-md-row justify-content-between gap-3">
      <h5
        *ngIf="container.title | floIsText"
        class="m-0"
        [ngClass]="
          [
            (!!container.title?.style ? container.title?.style : 'h5') | floCssClassSanitize,
          ]
        ">
        {{ container.title?.text }}
      </h5>
      <ng-container *ngIf="container?.title?.type === 'cell:decorated-text-web'">
        <flo-decorated-text-cell [item]="container.title"></flo-decorated-text-cell>
      </ng-container>
      <ng-container *ngIf="container?.onlyFavorites as onlyFavoritesToggle">
        <flo-toggle
          [toggleFilter]="onlyFavoritesToggle"
          [toggleOutline]="true"
          (toggledTo)="handleToggleClicked($event)"
        ></flo-toggle>
      </ng-container>
    </div>
    <ng-container *ngIf="container?.filters?.type === 'filter-set'">
      <flo-filter-set [filterSet]="container?.filters"></flo-filter-set>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'search'">
      <flo-search-input-next-gen [searchModel]="container?.filters.search" (search)="handleSearch($event)" class="search-min-width"></flo-search-input-next-gen>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'filter-search-set'">
      <div class="mx-n3 mx-sm-n45">
        <flo-search-filters
          [searchModel]="container?.filters.search"
          [filters]="container?.filters.filters"
          [filterByAction]="true"
          [searchByAction]="true"
        ></flo-search-filters>
      </div>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'tabs-search-set'">
        <flo-tabs-search-set [tabsSearchSet]="container?.filters"></flo-tabs-search-set>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'event-list-controls'">
      <flo-event-list-controls
        [tabItems]="container?.filters?.tabs"
        [filtersSection]="container?.filters?.filters"
        (search)="handleSearch({ searchTerm: $event })"
        [toggleFilter]="container?.filters?.toggleFilter"
        [calendarAction]="container?.filters?.calendarAction"
        (singleFilterClicked)="singleFilterClicked($event)"
      ></flo-event-list-controls>
    </ng-container>
    <ng-container *ngIf="!isLoading && container?.content?.type === 'container'; else loadingSpinner">
      <flo-container
        [container]="container?.content"
        (nextPage)="handleNextPage($event)"
      ></flo-container>
    </ng-container>
  </div>
</ng-container>
<ng-template #loadingSpinner>
  <div data-test="spinner" class="d-flex spinner-container w-100">
    <div class="spinner-border text-light d-flex m-auto"></div>
  </div>
</ng-template>
